var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LeaveWasApproved',{attrs:{"event":_vm.event,"summary":_vm.summary}},[_c('img',{staticClass:"tw-w-10 leavedates-header-logo",attrs:{"src":require("@/assets/icons/logo.svg"),"alt":"leavedates-logo"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }